import type { WireConsultantProfile } from '@evogard/contract';

/**
 * O nome de cada perfil na tela, escrito **uma vez** — o comercial e a lista
 * de voluntários do ERP (que vincula) leem daqui.
 *
 * A lista fechada é do contrato (`CONSULTANT_PROFILES`), e o
 * `satisfies Record<WireConsultantProfile, string>` faz um perfil novo quebrar
 * a compilação em vez de aparecer como `base_reativacao` cru numa tela e "Base
 * de reativação" na outra — e aqui o identificador cru apareceria dentro de uma
 * frase sobre quanto alguém recebe.
 *
 * **`null` não está aqui de propósito.** Ele não é um terceiro perfil: é "o
 * cadastro não sabe", e quem o traduz é `ProfileBadge`, com outra cor e outro
 * texto. Uma entrada `null: 'Consultor externo'` seria exatamente a suposição que
 * a coluna anulável existe para impedir.
 */
// @valor
export const PROFILE_LABEL = {
  interno: 'Consultor interno',
  externo: 'Consultor externo',
  base_reativacao: 'Base de reativação',
} as const satisfies Record<WireConsultantProfile, string>;
